import { FilterSelectedValue } from '../../../../hooks/filters/interfaces/filter-selected-value.interface';
import { useAppFindFilters } from '../../../../hooks/filters/use-app-filters.hook';
import { useFilterContext } from '../../provider/filter.provider';

import { FilterButtonDropdownComponent } from '../filter-button-dropdown/filter-button-dropdown.component';

import './filter-pane-header.component.scss';
export interface FilterPaneHeaderCommonComponentProps {
  variant?: 'stand-alone' | 'simple' | '';
  filterSelection: FilterSelectedValue[];
  disabled?: boolean;
  defaultLabel?: string;
  onSelect?(selectedValue: FilterSelectedValue): void;
}
export interface FilterPaneHeaderComponentProps
  extends FilterPaneHeaderCommonComponentProps {
  filterIds: string[];
}

export const FilterPaneHeaderComponent = ({
  onSelect,
  filterSelection,
  filterIds,
  variant = 'stand-alone',
  disabled,
  defaultLabel,
}: FilterPaneHeaderComponentProps) => {
  const filtersData = useFilterContext();
  const filters = useAppFindFilters(filtersData, filterIds);

  return (
    <div className="filter-pane-header-container">
      {filters?.map(
        (filter, index) =>
          filter && (
            <div className="filter-pane-header-item" key={filter.id}>
              <FilterButtonDropdownComponent
                onSelect={onSelect}
                variant={variant}
                key={index}
                filter={filter}
                filterSelection={filterSelection}
                disabled={disabled}
                defaultLabel={defaultLabel}
              />
            </div>
          ),
      )}
    </div>
  );
};
